import { render, staticRenderFns } from "./model.vue?vue&type=template&id=9142a430&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"
import style0 from "./model.vue?vue&type=style&index=0&id=9142a430&prod&lang=less&scoped=true"
import style1 from "./model.vue?vue&type=style&index=1&id=9142a430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9142a430",
  null
  
)

export default component.exports